const get = require('lodash/get');
const cookie = require('./utils/cookie');
const queryToObject = require('./utils/queryToObject');

const CHANNEL_TRACK_EVENT_NAME = 'Web.Click.MerchantProgramChannelName'
const CHANNEL_COOKIE_NAME = 'e_channel_name'

function runTracker (tracker, options, callback) {
  const queries = queryToObject();
  const channelNameFromUrl = typeof queries === 'object' ? queries['channel_name'] : null;
  const channelNameFromCookie = cookie.read(CHANNEL_COOKIE_NAME);
  const accountUuid = get(window, 'BOOTSTRAP_DATA.authentication.user.uuid', get(options, 'accountUuid'));
  const channelDurationInDays = get(window, 'BOOTSTRAP_DATA.tracking.channelDurationInDays', 2);

  if (channelNameFromUrl) {
    if (accountUuid) {
      return tracker.event({
        channel_name: channelNameFromUrl,
        accountUuid,
      }, CHANNEL_TRACK_EVENT_NAME, callback);
    } else {
      cookie.write(CHANNEL_COOKIE_NAME, channelNameFromUrl, channelDurationInDays)
    }
  }

  if (channelNameFromCookie && accountUuid) {
    cookie.write(CHANNEL_COOKIE_NAME, '', -1)
    return tracker.event({
      channel_name: channelNameFromCookie,
      accountUuid,
    }, CHANNEL_TRACK_EVENT_NAME, callback);
  }
}

module.exports = {
  runTracker,
  exposeTracker: function(tracker, window) {
    window.trackChannel = function trackChannel(options, callback) {
      try {
        // For the compatibility
        // We allow window.trackChannel('uuid') or window.trackChannel({ accountUuid: 'uuid' })
        const accountUuid = get(options, 'accountUuid') || options;

        if (!!accountUuid && typeof accountUuid === 'string') {
          runTracker(tracker, { accountUuid }, callback)
        }
      } catch (err) {
        console.error('Not able to fire the channel event: ', err)
      }
    }
  }
}